import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PreparedPopupGeneratedRecordInterface } from '@app/store/models/prepared-popup-generated-record.interface';
import { SocialHelper } from '@app/store/models/social-helper.interface';
import { Subject } from 'rxjs';
import { ErrorCode, PublicQrDetails, QrGeneratorNavigatorRATING } from 'shared-library';
import { CoreService } from 'src/app/modules/core/services/core.service';
import { FunctionsService } from 'src/app/modules/core/services/functions.service';
import { UserQrGeneratorService } from 'src/app/modules/user/services/user-qr-generator.service';

@Component({
  selector: 'app-qrs-rating',
  templateUrl: './qrs-rating.component.html',
  styleUrls: ['./qrs-rating.component.scss', '../qrs-wrapper.component.scss']
})
export class QrsRatingComponent implements OnInit {

  rating_sent = false
  submitting = false

  data_ori: string
  @Input() qr_url: string;
  @Input() short_id: string
  @Input() social_data: SocialHelper
  @Input() qr_details: PublicQrDetails
  data: QrGeneratorNavigatorRATING
  @Output() _error = new EventEmitter<ErrorCode>()
  success_popup_obs: Subject<PreparedPopupGeneratedRecordInterface> = new Subject<PreparedPopupGeneratedRecordInterface>()

  constructor(
    public readonly coreService: CoreService,
    public readonly functionService: FunctionsService,
    private qrGeneratorService: UserQrGeneratorService
  ) { }

  ngOnInit(): void {
    this.functionService.initializeTooltip()
    if (!this.short_id) {
      throw new Error("Short id is required");
    }
    if (!this.qr_details) {
      throw new Error("Qr Details is required");
    }
    this.data = this.qr_details.rating_data
    this.data_ori = JSON.stringify(this.data)
  }

  async sendRating() {
    if (this.submitting) return
    this.submitting = true
    try {
      await this.coreService.submitQRResponses(this.short_id, { ...this.data.rating, visit_info: this.qrGeneratorService.visitInfo() })
      this.data = JSON.parse(this.data_ori)
      this.success_popup_obs.next(this.qr_details.popups.success)
      this.rating_sent = true
    } catch (error) {
      this._error.emit(error?.message || ErrorCode.SOMETHING_WENT_WRONG_WHILE_PROCESSING_REQUEST)
    }
    this.submitting = false
  }
}
